module.exports = __webpack_public_path__ + "img/safari.139274a4.png";